// THIS FILE IS AUTO GENERATED
import { GenIcon } from '../lib';
export function MdArrowUpward(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
      }
    }]
  })(props);
}
;